import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { IUser } from '../../../services/auth.service';
import type { RootState } from '../../store';
import { IAgency, IListMenuAgency } from '../../../services/agencies.service';

type AuthState = {
  currentUser: IUser | null;
  currentAgency: IAgency | null;
  listMenuAgency: IListMenuAgency[];
  accessToken: string | null;
  refreshToken: string | null;
};

const initialState: AuthState = { currentUser: null, accessToken: null, refreshToken: null, currentAgency: null, listMenuAgency: [] };

const slice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    setCurrentUser: (state, { payload: { currentUser } }: PayloadAction<{ currentUser: IUser }>) => {
      state.currentUser = currentUser;
    },
    setCurrentAgency: (state, { payload: { currentAgency } }: PayloadAction<{ currentAgency: IAgency }>) => {
      state.currentAgency = currentAgency;
    },
    setListMenuAgency: (state, { payload: { listMenuAgency } }: PayloadAction<{ listMenuAgency: IListMenuAgency[] }>) => {
      state.listMenuAgency = listMenuAgency;
    },
    logout: () => initialState,
  },
});

export const { setCurrentUser, setCurrentAgency, setListMenuAgency, logout } = slice.actions;

export default slice.reducer;

export const selectAuth = (state: RootState) => state.auth;
